/* global $$epiforms */

const allLeadgenPages = document.querySelectorAll(".adm-div-leadgen-page");
const firstDropdownDefault = document.querySelector("input#MQ1")?.value?.trim();
const secondDropdownDefault = document.querySelector("input#MQ2")?.value?.trim();

for (const leadgenPage of allLeadgenPages) {
    const leadgenFileDownloadBtn = leadgenPage.querySelector(".adm-div-leadgen-success-message .adm-btn a");
    const successMessageSection = leadgenPage.querySelector(".adm-div-leadgen-success-message");
    const leadgenForm = leadgenPage.querySelector(".adm-div-leadgen-form");
    const epiServerForm = leadgenPage.querySelector(".EPiServerForms");
    const epiFormStatusSection = leadgenPage.querySelector(".Form__Status__Message");
    const allFormSelections = leadgenForm?.querySelectorAll(".FormSelection");
    const allFormInputs = leadgenForm?.querySelectorAll(".FormTextbox");
    const allFormErrorSpans = leadgenForm?.querySelectorAll(".Form__Element__ValidationError");
    const formSubmitBtn = leadgenForm?.querySelector(".FormSubmitButton");
    const formStatusSection = leadgenForm?.querySelector(".Form__Status");
    var submitErrorMessage = leadgenForm?.getAttribute("data-submit-error");
    const submitBtnAriaLabel = leadgenForm?.getAttribute("data-form-aria-submit");
    leadgenForm.removeAttribute("data-form-aria-submit");
    leadgenForm.removeAttribute("data-recaptcha-validation");
    leadgenForm.removeAttribute("data-submit-error");
    let formSubmissionErrorTag;
    let dataLayerObj = {};

    setupDropdowns();
    setupInputs();
    setupFileDownloadBtn();
    setupSuccessMessageTitle();
    replaceErrorSpanTag();
    addAriaLabelToElements();
    setupLeadSourceDescription();
    addFunctionsToNativeEpiformEvents();

    function setupDropdowns() {
        for (const selectionWrapper of allFormSelections) {
            const selectTag = selectionWrapper.querySelector("select");

            if (firstDropdownDefault) {
                setupSecondDropdown(selectionWrapper, selectTag);
                setupFirstDropdown(selectTag);
            }

            selectTag.addEventListener("change", () => removeErrorOnInput(selectionWrapper));
            selectTag.addEventListener("focusout", () => removeRedOutlinePriority());
        }
    }

    function setupInputs() {
        for (const inputWrapper of allFormInputs) {
            const inputTag = inputWrapper.querySelector("input, textarea");

            inputTag.addEventListener("input", () => removeErrorOnInput(inputWrapper));
            inputTag.addEventListener("focusout", () => removeRedOutlinePriority());
        }
    }

    function setupFileDownloadBtn() {
        const fileTarget = leadgenFileDownloadBtn?.parentElement.parentElement.getAttribute("data-file-target");
        if (fileTarget) {
            leadgenFileDownloadBtn.setAttribute("target", fileTarget);
            leadgenFileDownloadBtn.setAttribute("rel", "noopener noreferrer");
        } else {
            leadgenFileDownloadBtn.removeAttribute("target");
            leadgenFileDownloadBtn.removeAttribute("rel");
        }
    }

    function setupSuccessMessageTitle() {
        const title = successMessageSection?.querySelector("h1, h2, h4");
        if (title) {
            const h3tag = document.createElement("H3");
            h3tag.innerText = title.innerText;
            successMessageSection.replaceChild(h3tag, title);
        }
    }

    function replaceErrorSpanTag() {
        for (const errorSpanTag of allFormErrorSpans) {
            errorSpanTag.parentElement?.insertBefore(errorSpanTag, errorSpanTag.parentElement?.firstElementChild?.nextElementSibling);
        }
    }


    function addAriaLabelToElements() {
        formSubmitBtn.setAttribute("aria-label", submitBtnAriaLabel);
        formSubmitBtn.setAttribute("title", submitBtnAriaLabel);
    }

    function setupLeadSourceDescription() {
        const hiddenField = formSubmitBtn.previousElementSibling;
        const sourceDescription = getSourceDescription();
        const fullNewValue = hiddenField?.getAttribute("value") + "-" + sourceDescription;
        hiddenField.setAttribute("value", fullNewValue);
    }

    function getSourceDescription() {
        const validUtmParamsKeys = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "utm_adgroup", "utm_experiment"];
        const currentPageUrl = `${location.origin}${location.pathname}`;
        const urlParams = new URL(document.URL).searchParams;
        let validUtmParamsString = "";

        validUtmParamsKeys.forEach(paramKey => {
            const paramValue = urlParams.get(paramKey);
            const isFirstValidParamFound = validUtmParamsString.length < 1;

            if (paramValue) {
                validUtmParamsString += `${isFirstValidParamFound ? "?" : "&"}${paramKey}=${paramValue}`;
            }
        })

        return currentPageUrl + validUtmParamsString;
    }

    function addFunctionsToNativeEpiformEvents() {
        if (typeof $$epiforms !== 'undefined') {
            $$epiforms(document).ready(() => {
                $$epiforms(epiServerForm).on("formsStepValidating", () => {
                    leadgenForm.classList.add("adm-form-red-outline-priority");
                });

                $$epiforms(epiServerForm).on("formsStartSubmitting", () => {
                    setupDataLayerObj();
                });

                $$epiforms(epiServerForm).on("formsSubmitted", (e) => {
                    if (!e.isSuccess) {
                        formSubmissionErrorTag?.remove();
                        if (e.returnedResult?.message != null)
                            submitErrorMessage = sliceAfterWord(e.returnedResult?.message, "Reason: ")
                        showErrorMessage();
                        window.scroll({ top: leadgenPage.offsetTop, behavior: "smooth" });
                    }
                    if (e.isFinalizedSubmission && e.isSuccess) {
                        checkForReadonlyMode();
                    }
                });

                $$epiforms(epiServerForm).on("formsSubmittedError", () => {
                    showErrorMessage();
                });
            });
        }
    }

    function setupSecondDropdown(selectionWrapper, selectTag) {
        if (selectTag?.getAttribute("title")?.trim()?.toLowerCase() === firstDropdownDefault.toLowerCase()) {
            selectionWrapper.classList.remove("hide");
            if (secondDropdownDefault) {
                selectTag.value = secondDropdownDefault;
                selectTag?.dispatchEvent(new Event('change'));
            }
        }
    }

    function setupFirstDropdown(selectTag) {
        for (const option of selectTag?.options ?? []) {
            if (option.value === firstDropdownDefault) {
                selectTag.value = firstDropdownDefault;
                selectTag?.dispatchEvent(new Event('change'));
            }
        }
    }

    function removeErrorOnInput(fieldWrapper) {
        const validationMessage = fieldWrapper.querySelector(".Form__Element__ValidationError");
        if (fieldWrapper.classList.contains("ValidationFail")) {
            fieldWrapper.classList.remove("ValidationFail");
            validationMessage.style.display = "none";
        }
    }

    function removeRedOutlinePriority() {
        if (leadgenForm.classList.contains("adm-form-red-outline-priority")) {
            leadgenForm.classList.remove("adm-form-red-outline-priority");
        }
    }

    async function checkForReadonlyMode() {
        const response = await fetch(window.location.origin + '/FormsPage/GetDatabaseReadonly/');
        const readonlyBoolean = await response.json();
        if (readonlyBoolean) {
            leadgenPage.classList.add("adm-leadgen-form-maintenance-mode");
        } else {
            window.scroll({ top: leadgenPage.offsetTop, behavior: "smooth" });
            formSubmissionErrorTag?.remove();
            pushDataLayer();
            leadgenFileDownloadBtn.setAttribute("target", "_blank");
            leadgenFileDownloadBtn.setAttribute("rel", "noopener noreferrer");
            leadgenFileDownloadBtn.click();
            setTimeout(() => {
                setupFileDownloadBtn();
                epiFormStatusSection.appendChild(leadgenFileDownloadBtn.parentElement);
            }, 0);
        }
    }

    function showErrorMessage() {
        formSubmissionErrorTag = document.createElement("SPAN");
        formSubmissionErrorTag.innerText = submitErrorMessage;
        formSubmissionErrorTag.classList.add("adm-leadgen-custom-error-message");
        formStatusSection.appendChild(formSubmissionErrorTag)
    }

    function sliceAfterWord(str, word) {
        let index = str.indexOf(word);
        return index !== -1 ? str.slice(index + word.length) : str;
    }

    function setupDataLayerObj() {
        const allVisibleSelects = leadgenForm.querySelectorAll(".FormSelection:not(.hide) select");
        const allInputElements = leadgenForm.querySelectorAll(".FormTextbox input");
        const colectedData = [];

        colectedData.push(['event', 'leadgenformsuccess']);
        colectedData.push(['email_address', allInputElements[2]?.value?.toLowerCase()]);
        colectedData.push(['phone_number', allInputElements[3]?.value?.toLowerCase()]);
        colectedData.push(['industry_primary_selected', allVisibleSelects[0]?.value?.toLowerCase()]);

        if (allVisibleSelects.length > 2) {
            colectedData.push(['industry_sub_selected', allVisibleSelects[1]?.value?.toLowerCase()]);
        }

        dataLayerObj = {};
        for (const data of colectedData) {
            if (data[1]) {
                dataLayerObj[data[0]] = data[1];
            }
        }
    }

    function pushDataLayer() {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(dataLayerObj);
    }
}